import React, { useRef, useState } from "react";
import PrimaryButton from "../components/PrimaryButton";
import star from "../assets/images/star.png";
import userPlaceholderImage from "../assets/images/user.png";
import workspace from "../assets/icons/workspace_main.svg";
import ModalContainer from "../components/ModalContainer";
import icon from "../assets/images/Rectangle 18156.png";
import Circlebtn from "../components/Circlebtn";
import { BsArrowReturnRight } from "react-icons/bs";
import fb from "../assets/icons/facebook.svg";
import insta from "../assets/icons/insta.svg";
import yt from "../assets/icons/YT.svg";
import { FiClipboard } from "react-icons/fi";
import { BellIcon, ArrowDownIcon, SettingsIcon, SearchIcon } from "../assets/icons/Icons";
import { useRedirect } from "../hooks/useRedirect";
import pathnames from "../routes/index.route";
import SearchModal from "../components/SearchModal";
import MainModal from "../components/MainModal";
import { useAuth0 } from "@auth0/auth0-react";

const NotifyGeneralCard = () => {
  const { user } = useAuth0();
  return (
    <div className="w-full min-h-[106px] rounded-xl border boder-[#EAE9EF] p-3 mb-2">
      <div className="flex items-center justify-between mb-1.5">
        <div className="text-zinc-400 text-[10px] font-medium tracking-tight">24.12.2023 / 17:34</div>
        <div className="w-2 h-2 rounded-full bg-[#FF542E]" />
      </div>
      <div className="flex items-center justify-between gap-24 mb-3">
        <p className="text-[#0F0C18] text-xs font-medium leading-[18px] tracking-tight">Your video was successfuly translated and ready for usage.</p>
        <img src={icon} className="w-9 h-9 rounded-md" alt="img" />
      </div>
      <div className="flex items-center gap-1.5">
        <img src={userPlaceholderImage} className="w-4 h-4 rounded-full" alt="img" />
        <p className="text-zinc-400 text-xs font-medium tracking-tight">{`${user?.nickname}` || "Unknown User"}</p>
      </div>
    </div>
  );
}
const NotifySystemlCard = () => {
  return (
    <div className="w-full min-h-[78px] rounded-xl border boder-[#EAE9EF] p-3 mb-2">
      <div className="flex items-center justify-between mb-1.5">
        <div className="text-zinc-400 text-[10px] font-medium tracking-tight">24.12.2023 / 17:34</div>
        <div className="w-2 h-2 rounded-full bg-[#9392A2]" />
      </div>
      <div className="w-[70%]">
        <p className="text-[#0F0C18] text-xs font-medium leading-[18px] tracking-tight">Your payment was applied to your account. Now you have 1,356 points.</p>
      </div>
    </div>
  );
}

const Notifications = () => {
  const [showIndex, setShowIndex] = useState(1);
  return (
    <>
      <h1 className="text-[#0F0C18] text-[28px] font-medium leading-9 tracking-tight mb-3">Notifications</h1>
      <div className="w-[358px] h-[36px] rounded-full border border-[#EAE9EF] flex items-center p-[1px] mb-3">
        <div
          onClick={() => setShowIndex(1)}
          className={`w-[50%] h-[33px] rounded-full flex items-center justify-center gap-1 cursor-pointer transition duration-300 ease-in-out ${showIndex === 1 && "bg-[#EAE9EF]"}`}
        >
          <p className={`text-center text-sm font-medium tracking-tight select-none ${showIndex === 1 ? "text-[#0F0C18]" : "text-[#9392A2]"}`}>General</p>
          <div className={`w-4 h-4 flex items-center justify-center bg-[#FF542E] rounded-full font-medium text-white`}> <div className="text-[10px] mt-[0.8px] ml-[0.5px]">3</div> </div>
        </div>
        <div
          onClick={() => setShowIndex(2)}
          className={`w-[50%] h-[33px] rounded-full flex items-center justify-center gap-1 cursor-pointer transition duration-300 ease-in-out ${showIndex === 2 && "bg-[#EAE9EF]"}`}
        >
          <p className={`text-center text-sm font-medium tracking-tight select-none ${showIndex === 2 ? "text-[#0F0C18]" : "text-[#9392A2]"}`}>System</p>
        </div>

      </div>
      {
        showIndex === 1 &&
        <div>
          <NotifyGeneralCard />
          <NotifyGeneralCard />
          <NotifyGeneralCard />
        </div>
      }
      {
        showIndex === 2 &&
        <div>
          <NotifySystemlCard />
          <NotifySystemlCard />
          <NotifySystemlCard />
        </div>
      }
    </>
  );
}

const Workspaces = () => {
  const { user } = useAuth0();

  return (
    <>
      <div className="flex items-center justify-between">
        <h1 className="text-[#0F0C18] text-[28px] font-medium leading-9 tracking-tight">Workspaces</h1>
        <Circlebtn icon={<SettingsIcon />} className="w-8 h-8 bg-[#F1F2F8]" />
      </div>
      <div className="flex items-center justify-between mt-4">
        <p className="text-[#9392A2] text-xs font-medium tracking-tight">5 workspaces</p>
        <div className="flex items-center gap-1">
          <img src={userPlaceholderImage} className="w-4 h-4 rounded-full" alt="user" />
          <p className="text-[#0F0C18] text-xs font-medium tracking-tight">{`${user?.nickname}` || "Unknown User"}</p>
        </div>
      </div>
      <div>
        <div className="p-3 bg-[#EAE9EF] rounded-xl mt-3 mb-2">
          <div className="flex items-start justify-between">
            <div className="flex items-center gap-2.5">
              <img src={workspace} className="w-10 h-10 rounded-full" alt="workspace" />
              <div>
                <div className="text-[#0F0C18] text-base font-medium tracking-tight">Andrew’s workspace</div>
                <div className="text-[#9392A2] text-xs font-medium tracking-tight">$ 1,345.92 on balance</div>
              </div>
            </div>
            <SettingsIcon />
          </div>
          <div className="mt-3.5 flex items-start gap-[22px]">
            <BsArrowReturnRight className="w-4 h-4 ml-3 text-[#9392A2]" />
            <div className="w-full">
              <div className="flex items-center justify-between">
                <p className="text-[#0F0C18] text-xs font-medium tracking-tight">3 social networks</p>
                <div className="flex items-center">
                  <img src={fb} className="w-4 h-4 rounded-full" alt="fb" />
                  <img src={insta} className="w-4 h-4 rounded-full -ml-1.5" alt="fb" />
                  <img src={yt} className="w-4 h-4 rounded-full -ml-1.5" alt="fb" />
                </div>
              </div>
              <div className="flex items-center justify-between mt-3.5">
                <p className="text-[#0F0C18] text-xs font-medium tracking-tight">5 users connected</p>
                <div className="flex items-center">
                  <p className="text-[#9392A2] text-xs font-medium font-['Aeonik Pro'] tracking-tight mr-2">+2</p>
                  <img src={userPlaceholderImage} className="w-4 h-4 rounded-full" alt="fb" />
                  <img src={userPlaceholderImage} className="w-4 h-4 rounded-full -ml-1.5" alt="fb" />
                  <img src={userPlaceholderImage} className="w-4 h-4 rounded-full -ml-1.5" alt="fb" />
                </div>
              </div>
              <div className="flex items-center justify-between mt-3.5">
                <p className="text-[#0F0C18] text-xs font-medium tracking-tight">12 content groups & 125 files</p>
                <div className="flex items-center">
                  <FiClipboard className="text-sm text-[#0F0C18]" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-3 rounded-xl mt-3 mb-2 border border-[#EAE9EF]">
          <div className="flex items-start justify-between">
            <div className="flex items-center gap-2.5">
              <img src={workspace} className="w-10 h-10 rounded-full" alt="workspace" />
              <div>
                <div className="text-[#0F0C18] text-base font-medium tracking-tight">Only4Values</div>
                <div className="text-[#9392A2] text-xs font-medium tracking-tight">$ 5,345.92 on balance</div>
              </div>
            </div>
          </div>
        </div>
        <div className="text-[#9392A2] text-xs font-medium mt-4 tracking-tight">Invites</div>
        <div className="p-3 rounded-xl mt-2 mb-2 border border-[#EAE9EF]">
          <div className="flex items-start justify-between">
            <div className="flex items-center gap-2.5">
              <img src={workspace} className="w-10 h-10 rounded-full" alt="workspace" />
              <div>
                <div className="text-[#0F0C18] text-base font-medium tracking-tight">Andrew’s workspace</div>
                <div className="text-[#9392A2] text-xs font-medium tracking-tight">$ 1,345.92 on balance</div>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-3 mt-3">
            <PrimaryButton className="py-1.5 text-sm rounded-3xl w-full" label="Decline" black />
            <PrimaryButton className="py-1.5 text-sm rounded-3xl w-full" label="Accept" />
          </div>
        </div>
      </div>
    </>
  );
}

const Navbar = () => {
  const [isNotifyModalOpen, setIsNotifyModalOpen] = useState<boolean>(false);
  const [isSearchOpen, setIsSearchOpen] = useState<boolean>(false);
  const [isWorkspacesOpen, setIsWorkspacesOpen] = useState<boolean>(false);
  const notifyModalRef = useRef<HTMLDivElement>(null);
  const bellRef = useRef<HTMLDivElement>(null);
  const workspacesModalRef = useRef<HTMLDivElement>(null);
  const workspacesRef = useRef<HTMLDivElement>(null);
  const redirect = useRedirect();
  const { user } = useAuth0();
  console.log('user', user);

  return (
    <div className="max-w-full h-[64px] bg-white border-b border-[#EAEFF4] mt-2 mr-2 rounded-2xl flex items-center justify-between px-4">
      <div onClick={() => setIsSearchOpen(true)}>
        <div
          className={`p-2 px-3 rounded-full flex items-center gap-2 cursor-text bg-[#EAE9EF] w-[391px] text-xs`}
        >
          <SearchIcon />
          <div className={`font-medium text-[#9392A2] flex-grow outline-none bg-[#EAE9EF]`} >
            Search anything...
          </div>
        </div>
      </div>
      <div className="flex items-center gap-4">
        <div onClick={() => redirect(pathnames.settings + pathnames.UpgradePlan)} className="bg-[#EAE9EF] flex items-center justify-between rounded-full relative overflow-hidden w-[305px] cursor-pointer">
          <img src={star} className="w-[117.8px] absolute -left-[41px]" alt="star" />
          <p className="text-[#0F0C18] text-xs font-medium tracking-tight ml-12">Upgrade & enjoy all benefits.</p>
          <PrimaryButton className="px-4 rounded-full py-1.5" label="Upgrade" labelStyle="text-sm font-medium" />
        </div>
        <div className="w-[1px] h-16 bg-[#EAE9EF]" />
        <div ref={workspacesRef} onClick={() => setIsWorkspacesOpen(prev => !prev)} className="flex items-center gap-2 cursor-pointer">
          <div className="flex items-center">
            <img src={user?.picture || userPlaceholderImage} className="w-8 h-8 rounded-full -mr-[10px] z-30" alt="user" />
            <img src={workspace} className="w-8 h-8 rounded-full z-20" alt="workspace" />
          </div>
          <div>
            <p className="text-[#0F0C18] text-xs font-medium tracking-tight">Super company</p>
            <p className="text-[#9392A2] text-[10px] font-medium tracking-tight">$ 1,345.92 on balance</p>
          </div>
          <ArrowDownIcon />
        </div>
        <div className="w-[1px] h-16 bg-[#EAE9EF]" />
        <div ref={bellRef} className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center relative cursor-pointer" onClick={() => setIsNotifyModalOpen((prev) => !prev)}>
          <BellIcon />
          <div className="w-2 h-2 bg-orange-400 rounded-full border border-white absolute right-0 top-0" />
        </div>
      </div>
      {isNotifyModalOpen && (
        <ModalContainer
          modalRef={notifyModalRef}
          divRef={bellRef}
          setIsModalOpen={setIsNotifyModalOpen}
          width="389px"
          minHeight="378px"
          maxHeight="712px"
          top="80px"
          right="8px"
          className="p-4 shadow-xl"
        >
          <Notifications />
        </ModalContainer>
      )}
      {
        isSearchOpen && (
          <MainModal
            setShowModal={setIsSearchOpen}
            header={true}
            btnStyle="normal"
            width="766px"
            className="bg-white px-0"
          >
            <SearchModal />
          </MainModal>
        )
      }
      {isWorkspacesOpen && (
        <ModalContainer
          modalRef={workspacesModalRef}
          divRef={workspacesRef}
          setIsModalOpen={setIsWorkspacesOpen}
          width="390px"
          minHeight="478px"
          maxHeight="547px"
          top="80px"
          right="8px"
          className="p-4 shadow-xl"
        >
          <Workspaces />
        </ModalContainer>
      )}
    </div>
  );
};

export default Navbar;